import { createAction, props } from '@ngrx/store';

import { PresenceReportActions } from '~/repositories/presence-report/store/presence-report.const';
import {
  PresenceReportGroupEntity,
  PresenceReportRequestEntity
} from '~/repositories/presence-report/store/presence-report.models';

export const fetchOrgans = createAction(PresenceReportActions.fetchOrgans);
export const fetchOrgansSuccess = createAction(
  PresenceReportActions.fetchOrgansSuccess,
  props<{ organs: PresenceReportGroupEntity[] }>()
);
export const fetchOrgansFailure = createAction(PresenceReportActions.fetchOrgansFailure, props<{ error: any }>());

export const publishPresenceReportDetails = createAction(
  PresenceReportActions.publishPresenceReportDetails,
  props<{
    presenceReportRequestEntity: PresenceReportRequestEntity;
  }>()
);

export const publishPresenceReportDetailsSuccess = createAction(
  PresenceReportActions.publishPresenceReportDetailsSuccess
);

export const publishPresenceReportDetailsFailure = createAction(
  PresenceReportActions.publishPresenceReportDetailsFailure,
  props<{ error: any }>()
);
